/* KWD header: free-shipping progress (desktop cart chip + mobile 2nd top bar),
   nav, region + producer maps. No geo-IP. No delivery-time/cutoff/local claims.

   2026-07-26: the free-shipping meter and the cart chip amount used to paint
   ONCE on boot from the Liquid-rendered data-cart-total, so any AJAX add /
   quantity change left both frozen until a full page reload. They now re-paint
   from /cart.js after every cart mutation (fetch + XHR are both hooked, so it
   works no matter which script fires the request). Fires a `kwd:cart:updated`
   DOM event with the fresh cart object. */
(function(){
  'use strict';
  var FREE_CENTS = 15000;
  var CLUSTER_FROM = 60;
  var CDN = 'https://cdnjs.cloudflare.com/ajax/libs/';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  function $(s,r){return (r||document).querySelector(s);}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}

  function readJSON(id){var el=document.getElementById(id);if(!el)return null;try{return JSON.parse(el.textContent);}catch(e){return null;}}
  function allPins(){ return readJSON('kwd-atlas-pins') || readJSON('kwd-spirits-data') || []; }
  function spiritsPins(){
    var full=readJSON('kwd-atlas-pins');
    if(full) return full.filter(function(p){return p.k==='distillery';});
    return readJSON('kwd-spirits-data') || [];
  }

  /* ---------- cart chip + free-shipping meter ---------- */

  function money(cents){
    return '$'+(cents/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
  }

  function paintCount(n){
    var link=$('.kwd-cart'); if(!link) return;
    var el=document.getElementById('CartCount');
    if(!el && n>0){
      el=document.createElement('span');
      el.id='CartCount'; el.className='site-header__cart-count';
      el.style.display='none';
      el.innerHTML='<span class="car_one"></span>';
      link.appendChild(el);
    }
    if(!el) return;
    var inner=el.querySelector('.car_one')||el;
    inner.textContent=n;
    if(n>0) el.classList.remove('hidden-count');
  }

  function paint(total,count){
    var hd=$('.kwd-hd');
    if(hd) hd.setAttribute('data-cart-total',total);

    var rem=FREE_CENTS-total, txt, pct;
    /* Within one shipping charge ($20, the cheapest paid rate in any zone that
       has a free tier) topping up is cheaper than shipping. Flag it here too, so
       a shopper still browsing sees it before they ever open the cart. */
    var close = total>0 && total<FREE_CENTS && total>=(FREE_CENTS-2000);
    if(total>=FREE_CENTS){ txt='Free shipping unlocked'; pct=100; }
    else if(close){ txt='Only '+money(rem)+' to free shipping'; pct=total/FREE_CENTS*100; }
    else if(total>0){ txt=money(rem)+' to free shipping'; pct=total/FREE_CENTS*100; }
    else { txt='Free shipping over $150'; pct=0; }
    pct=Math.max(0,Math.min(100,pct));

    var amt=$('.kwd-cart .amt'); if(amt) amt.textContent=money(total);
    var sub=$('#kwd-cart-sub'); if(sub) sub.textContent=txt;
    /* classList, never className: this span is <span class="sub" id="kwd-cart-sub">
       and .kwd-cart .sub is display:none inside the mobile media query. Assigning
       className wipes `sub`, which un-hides the line on phones and prints the
       free-shipping message twice in the header on every page. */
    if(sub){ if(close) sub.classList.add('kwd-close'); else sub.classList.remove('kwd-close'); }
    var fill=$('#kwd-bar-fill'); if(fill) fill.style.width=pct+'%';

    var hdw=$('.kwd-hd');
    if(hdw){ if(close) hdw.classList.add('kwd-hd--close'); else hdw.classList.remove('kwd-hd--close'); }

    var mtxt=$('#kwd-ship-m-txt');
    if(mtxt){
      if(close) mtxt.innerHTML='Only <b>'+money(rem)+'</b> to free shipping';
      else if(total>0 && total<FREE_CENTS) mtxt.innerHTML='<b>'+money(rem)+'</b> to free shipping';
      else mtxt.textContent=txt;
    }
    var mfill=$('#kwd-ship-m-fill'); if(mfill) mfill.style.width=pct+'%';

    if(typeof count==='number') paintCount(count);
  }

  function bar(){
    var hd=$('.kwd-hd'); if(!hd) return;
    paint(parseInt(hd.getAttribute('data-cart-total'),10)||0);
  }

  /* `reason` rides along on the kwd:cart:updated event so listeners (the sound
     layer) can tell an add apart from a quantity nudge or a line removal. */
  function reasonFor(url){ var m=CART_WRITE.exec(url||''); return m ? m[1].toLowerCase() : 'poll'; }

  var syncTimer=null, syncSeq=0, syncReason='init';
  function sync(reason){
    if(reason) syncReason=reason;
    clearTimeout(syncTimer);
    syncTimer=setTimeout(function(){
      var mine=++syncSeq, why=syncReason;
      syncReason='poll';
      fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(cart){
          if(!cart || mine!==syncSeq) return;
          /* The $2 gift-card add-on is not a bottle; keep it out of the badge. */
          var giftQty=0;
          (cart.items||[]).forEach(function(it){ if(it.handle==='personalized-gift-card'||it.handle==='gift-bag'){ giftQty+=it.quantity; } });
          paint(cart.total_price,cart.item_count-giftQty);
          try{ document.dispatchEvent(new CustomEvent('kwd:cart:updated',{detail:{cart:cart,reason:why}})); }catch(e){}
        })
        .catch(function(){});
    },70);
  }

  function watchCart(){
    if(window.fetch){
      var orig=window.fetch;
      window.fetch=function(input){
        var url='';
        try{ url=(typeof input==='string')?input:((input&&input.url)||''); }catch(e){}
        var p=orig.apply(this,arguments);
        if(CART_WRITE.test(url)){
          try{ p.then(function(res){ if(res&&res.ok) sync(reasonFor(url)); },function(){}); }catch(e){}
        }
        return p;
      };
    }
    var open=XMLHttpRequest.prototype.open, send=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open=function(m,u){ try{ this.__kwdUrl=u; }catch(e){} return open.apply(this,arguments); };
    XMLHttpRequest.prototype.send=function(){
      var x=this, u=x.__kwdUrl||'';
      if(CART_WRITE.test(u)){
        x.addEventListener('load',function(){ if(x.status>=200&&x.status<300) sync(reasonFor(u)); });
      }
      return send.apply(this,arguments);
    };
    window.addEventListener('pageshow',function(e){ if(e.persisted) sync('poll'); });
    document.addEventListener('visibilitychange',function(){ if(!document.hidden) sync('poll'); });
    window.KWDCart={ sync:sync, paint:paint };
  }

  /* ---------- nav ---------- */

  function nav(){
    $$('.kwd-item').forEach(function(it){
      var close;
      it.addEventListener('mouseenter',function(){
        clearTimeout(close);
        $$('.kwd-item').forEach(function(x){if(x!==it)x.classList.remove('open');});
        if(it.querySelector('.kwd-mega')){it.classList.add('open');initMap(it);}
      });
      it.addEventListener('mouseleave',function(){ close=setTimeout(function(){it.classList.remove('open');},160); });
      var top=it.querySelector('a.top');
      if(top && !top.classList.contains('kwd-atlas-open')){
        top.addEventListener('click',function(e){
          if(window.matchMedia('(hover:none)').matches && it.querySelector('.kwd-mega')){
            e.preventDefault(); it.classList.toggle('open'); initMap(it);
          }
        });
      }
    });
  }

  function css(href){ if(document.querySelector('link[href="'+href+'"]'))return; var l=document.createElement('link');l.rel='stylesheet';l.href=href;document.head.appendChild(l); }
  function js(src){ return new Promise(function(res){var s=document.createElement('script');s.src=src;s.onload=function(){res(true);};s.onerror=function(){res(false);};document.head.appendChild(s);}); }
  var leafletP=null;
  function leaflet(){
    if(leafletP) return leafletP;
    leafletP=new Promise(function(res){
      if(window.L){res(window.L);return;}
      css(CDN+'leaflet/1.9.4/leaflet.min.css');
      js(CDN+'leaflet/1.9.4/leaflet.min.js').then(function(ok){ res(ok?window.L:null); });
    });
    return leafletP;
  }
  var clusterP=null;
  function cluster(){
    if(clusterP) return clusterP;
    clusterP=new Promise(function(res){
      if(window.L && window.L.markerClusterGroup){res(true);return;}
      css(CDN+'leaflet.markercluster/1.5.3/MarkerCluster.css');
      js(CDN+'leaflet.markercluster/1.5.3/leaflet.markercluster.js').then(function(ok){ res(!!(ok && window.L && window.L.markerClusterGroup)); });
    });
    return clusterP;
  }

  function pinTip(p){ var t='<b>'+p.n+'</b>'; if(p.r) t+='<br>'+p.r; if(p.b) t+='<br>'+p.b+' bottle'+(p.b===1?'':'s'); return t; }
  function addPins(L,map,pins,zoom,useCluster){
    function marker(p){
      return L.circleMarker([p.lat,p.lon],{radius:zoom>1?6:4.5,color:'#5A1229',weight:1.2,fillColor:p.k==='winery'?'#A32348':'#C9A227',fillOpacity:.95})
        .bindTooltip(pinTip(p),{direction:'top',offset:[0,-3]}).on('click',function(){ if(p.u) window.location.href=p.u; });
    }
    if(useCluster && L.markerClusterGroup){
      var g=L.markerClusterGroup({showCoverageOnHover:false,maxClusterRadius:38,spiderfyOnMaxZoom:true,
        iconCreateFunction:function(c){var n=c.getChildCount(),size=n<10?28:(n<50?34:42);return L.divIcon({html:'<span>'+n+'</span>',className:'kwd-cluster',iconSize:L.point(size,size)});}});
      pins.forEach(function(p){ g.addLayer(marker(p)); }); map.addLayer(g);
    } else { pins.forEach(function(p){ marker(p).addTo(map); }); }
  }
  function draw(L,el,opts){
    var regions=opts.regions||[], producers=(opts.producers||[]).filter(function(p){return typeof p.lat==='number'&&typeof p.lon==='number';});
    var zoom=opts.zoom||1;
    var map=L.map(el,{zoomControl:zoom>1,attributionControl:false,scrollWheelZoom:false,dragging:true,worldCopyJump:false,maxBounds:[[-75,-175],[85,185]],maxBoundsViscosity:.9,minZoom:1}).setView([30,10],zoom);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',{subdomains:'abcd',maxZoom:10,noWrap:true}).addTo(map);
    try{map.getPanes().tilePane.style.filter='sepia(.35) saturate(.85) brightness(1.02)';}catch(e){}
    if(regions.length){
      var mx=Math.max.apply(null,regions.map(function(r){return r.c;}))||1;
      regions.forEach(function(r){ if(!r.c)return; var rad=(zoom>1?8:6)+Math.sqrt(r.c/mx)*(zoom>1?26:20);
        L.circleMarker([r.lat,r.lon],{radius:rad,color:'#C9A227',weight:1.4,fillColor:'#A32348',fillOpacity:.5}).addTo(map)
         .bindTooltip(r.n+' · '+r.c+' bottles',{direction:'top',offset:[0,-4]}).on('click',function(){window.location.href='/collections/'+r.h;}); });
    }
    function afterPins(){ setTimeout(function(){ map.invalidateSize();
      if(opts.fit){ var pts=producers.map(function(p){return [p.lat,p.lon];}).concat(regions.map(function(r){return [r.lat,r.lon];})); if(pts.length) map.fitBounds(L.latLngBounds(pts),{padding:[50,50],maxZoom:5}); } },140); }
    if(producers.length && producers.length>=CLUSTER_FROM){ cluster().then(function(ok){ addPins(L,map,producers,zoom,ok); afterPins(); }); }
    else { if(producers.length) addPins(L,map,producers,zoom,false); afterPins(); }
    return map;
  }
  function boxOpts(box){ if(box.getAttribute('data-src')==='spirits') return {producers:spiritsPins()}; return {regions:JSON.parse(box.getAttribute('data-regions')||'[]')}; }
  function initMap(item){
    var box=item.querySelector('.kwd-mapbox'); if(!box||box.dataset.ready) return;
    var o=boxOpts(box); if(!(o.regions&&o.regions.length)&&!(o.producers&&o.producers.length)) return;
    box.dataset.ready='1'; leaflet().then(function(L){ if(L) draw(L,box.querySelector('.m'),o); });
  }
  function openAtlas(opts){
    var ov=$('#kwd-atlas'); if(!ov) return; ov.classList.add('on');
    if(!ov.dataset.ready){ ov.dataset.ready='1'; opts.zoom=2; opts.fit=true; leaflet().then(function(L){ if(L) ov._m=draw(L,$('.m',ov),opts); }); }
    else if(ov._m){ setTimeout(function(){ov._m.invalidateSize();},80); }
  }
  function atlas(){
    var ov=$('#kwd-atlas'); if(!ov) return;
    $$('.kwd-mapbtn').forEach(function(b){ b.addEventListener('click',function(e){ e.preventDefault(); openAtlas(boxOpts(b.parentNode)); }); });
    $$('.kwd-atlas-open').forEach(function(b){ b.addEventListener('click',function(e){ e.preventDefault(); openAtlas({regions:JSON.parse(b.getAttribute('data-regions')||'[]'),producers:allPins()}); }); });
    var c=$('#kwd-atlas-close'); if(c) c.addEventListener('click',function(){ov.classList.remove('on');});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')ov.classList.remove('on');});
  }

  function boot(){ bar(); watchCart(); sync('init'); nav(); atlas(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

